export default "__VITE_ASSET__96167ac1__"